import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { EdiStyle } from "@enums/ediStyle.enum";
import { EDIType } from "@enums/ediType.enum";
import { InteractionType } from "@enums/interactionType.enum";
import { GetPropertiesFromEnum } from "@helpers/getPropertiesFromEnum";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { BankDetails } from "@interfaces/bankDetails.interface";
import { ClientContact } from "@interfaces/clientContact.interface";
import { ClientDocument } from "@interfaces/clientDocument.interface";
import { ClientInteraction } from "@interfaces/clientInteraction.interface";
import { ClientLocation } from "@interfaces/clientLocation.interface";
import { Client } from "@interfaces/models/client.interface";
import { OutsideProcessType } from "@interfaces/models/outsideProcessType.interface";
import { OutsourcedSpecification } from "@interfaces/models/outsourcedSpecification.interface";
import { PaymentTerm } from "@interfaces/models/paymentTerm.interface";
import { UserProfile } from "@interfaces/userProfile.interface";
import { AuthService } from "@services/auth.service";
import { BankDetailsService } from "@services/bankDetails.service";
import { ClientService } from "@services/client.service";
import { ClientContactService } from "@services/clientContact.service";
import { ClientDocumentService } from "@services/clientDocument.service";
import { ClientInteractionService } from "@services/clientInteraction.service";
import { ClientLocationService } from "@services/clientLocation.service";
import { CrmLeadService } from "@services/crmLead.service";
import { FileService } from "@services/file.service";
import { OutsideProcessTypeService } from "@services/outsideProcessType.service";
import { OutsourcedSpecificationService } from "@services/outsourcedSpecification.service";
import { PaymentTermService } from "@services/paymentTerm.service";
import { UserProfileService } from "@services/userProfile.service";
import { ToastService } from "angular-toastify";

@Component({
	moduleId: module.id,
	selector: "clients-id",
	styleUrls: ["clients-id.css"],
	templateUrl: "clients-id.html"
})
export class ClientIdAdminComponent {
	bankDetails: BankDetails[] = [];
	contacts: ClientContact[] = [];
	createEnabled = true;
	documents: ClientDocument[] = [];
	ediStyles: any;
	ediTypes: any;
	editEnabled = true;
	headerPrimaryButtons: AdminHeaderButton[] = [];
	headerTertiaryButtons: AdminHeaderButton[] = [];
	interactionTypes: any[] = [];
	interactions: ClientInteraction[] = [];
	item: Client = new Client();
	itemId = 0;
	itemType = "Client";
	locations: ClientLocation[] = [];
	outsideProcessTypes: OutsideProcessType[] = [];
	outsourcedSpecifications: OutsourcedSpecification[] = [];
	paymentTerms: PaymentTerm[] = [];
	popupAddButtonOptions: any = { onClick: () => this.addNewContact(), text: "Add Contact" };
	popupClientDocument: ClientDocument = new ClientDocument();
	popupCloseButtonOptions: any = { onClick: () => this.closePopup(), text: "Close" };
	popupContact: ClientContact = new ClientContact();
	popupInteraction: ClientInteraction = new ClientInteraction();
	popupLocation: ClientLocation = new ClientLocation();
	popupSpecification: OutsourcedSpecification = new OutsourcedSpecification();
	popupTitle = "Add New Contact";
	popupType = "Contact";
	popupVisible = false;
	readOnly = true;
	returnUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	statuses: any;
	title: string = "View " + this.itemType;
	uploadEnabled = false;
	userProfile: UserProfile = new UserProfile();
	userProfiles: UserProfile[] = [];

	constructor(private router: Router, private toastService: ToastService, private route: ActivatedRoute, private bankDetailsService: BankDetailsService, private clientContactsService: ClientContactService, private clientDocumentService: ClientDocumentService, private clientLocationService: ClientLocationService, private crmLeadService: CrmLeadService, private fileService: FileService, private itemService: ClientService, private outsideProcessTypeService: OutsideProcessTypeService, private outsourceService: OutsourcedSpecificationService, private paymentTermsService: PaymentTermService, private clientInteractionService: ClientInteractionService, private userProfileService: UserProfileService, private authService: AuthService) {
		this.getOutsideProcessTypes();
		this.getUserProfile();
		this.getUserProfiles();
		this.interactionTypes = GetPropertiesFromEnum(InteractionType);
		this.ediStyles = GetPropertiesFromEnum(EdiStyle);
		this.ediTypes = GetPropertiesFromEnum(EDIType, true);
		this.downloadDocument = this.downloadDocument.bind(this);
		this.uploadFile = this.uploadFile.bind(this);
		this.buildButtons("view");
		this.deleteContact = this.deleteContact.bind(this);
		this.deleteSpecification = this.deleteSpecification.bind(this);
		this.editContactPopup = this.editContactPopup.bind(this);
		this.editLocationPopup = this.editLocationPopup.bind(this);
		this.editSpecificationPopup = this.editSpecificationPopup.bind(this);
		this.setPrimaryBilling = this.setPrimaryBilling.bind(this);
		this.setPrimaryDelivery = this.setPrimaryDelivery.bind(this);
		this.route.params
			.subscribe((params) => {
				if (params.id != "create") {
					if (params.id.split("_").length > 1) {
						this.itemId = params.id.split("_")[0];
						this.getItem(this.itemId);
						this.edit();
					} else {
						this.itemId = params.id;
						this.getItem(params.id);
					}
				} else {
					this.create();
				}
			});
		this.getBankDetails();
		this.getPaymentTerms();
	}

	addDocumentPopup() {
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.createClientDocument(), text: "Add Document" };
		this.popupTitle = "Add Document";
		this.popupType = "Document";
	}

	addNewContact() {
		this.popupContact.clientId = this.item.id;
		this.clientContactsService.createSingle(this.popupContact)
			.subscribe(
				() => {
					this.closePopup();
					this.getContacts(this.item.id);
				},
				(err: any) => console.log(err)
			);
	}

	addNewContactPopup() {
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.addNewContact(), text: "Add Contact" };
		this.popupCloseButtonOptions = { onClick: () => this.closePopup(), text: "Close" };
		this.popupContact = new ClientContact();
		this.popupTitle = "Add New Contact";
		this.popupType = "Contact";
	}

	addNewInteractionPopup() {
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.createInteraction(), text: "Add Interaction" };
		this.popupCloseButtonOptions = { onClick: () => this.closePopup(), text: "Close" };
		this.popupInteraction = new ClientInteraction();
		this.popupTitle = "Add New Interaction";
		this.popupType = "Interaction";
	}

	addNewLocation() {
		this.popupLocation.clientId = this.item.id;
		this.clientLocationService.createSingle(this.popupLocation)
			.subscribe(
				() => {
					this.closePopup();
					this.getLocations(this.item.id);
				},
				(err: any) => console.log(err)
			);
	}

	addNewLocationPopup() {
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.addNewLocation(), text: "Add Location" };
		this.popupLocation = new ClientLocation();
		this.popupTitle = "Add New Location";
		this.popupType = "Location";
	}

	addNewSpec() {
		this.popupSpecification.clientId = this.item.id;
		this.outsourceService.createSingle(this.popupSpecification)
			.subscribe(
				() => {
					this.closePopup();
					this.getSpecifications(this.item.id);
				},
				(err: any) => console.log(err)
			);
	}

	addNewSpecificationPopup() {
		this.popupVisible = true;
		this.popupAddButtonOptions = { onClick: () => this.addNewSpec(), text: "Add Specification" };
		this.popupSpecification = new OutsourcedSpecification();
		this.popupTitle = "Add New Specification";
		this.popupType = "Specification";
	}

	boolYesNo(cellInfo: any) {
		if (cellInfo.value === true) {
			return "YES";
		}
		else {
			return "NO";
		}
	}

	buildButtons(mode: string) {
		if (mode == "edit" && this.editEnabled) {
			this.headerPrimaryButtons = [
				{ method: "updateItem", text: "Save Changes" },
				{ method: "cancelEditing", text: "View Mode" },
				{ method: "close", text: "Close" }
			];
			this.headerTertiaryButtons = [
				{ method: "addNewContactPopup", text: "Add Contact" },
				{ method: "addDocumentPopup", text: "Add Document" },
				{ method: "addNewLocationPopup", text: "Add Location" },
				{ method: "addNewSpecificationPopup", text: "Add Spec" },
				{ method: "addNewInteractionPopup", text: "Add Interaction" }
			];
		} else if (mode == "create" && this.createEnabled) {
			this.headerPrimaryButtons = [
				{ method: "createItem", text: "Save" },
				{ method: "close", text: "Close" }
			];
			this.headerTertiaryButtons = [];
		} else if (mode == "view") {
			this.headerTertiaryButtons = [
				{ method: "addNewContactPopup", text: "Add Contact" },
				{ method: "addDocumentPopup", text: "Add Document" },
				{ method: "addNewLocationPopup", text: "Add Location" },
				{ method: "addNewSpecificationPopup", text: "Add Spec" },
				{ method: "addNewInteractionPopup", text: "Add Interaction" }
			];
			this.headerPrimaryButtons = [
				{ method: "generateLead", text: "Create CRM Lead" },
				{ method: "edit", text: "Edit" },
				{ method: "close", text: "Close" }
			];
		}
	}

	cancelEditing() {
		if (confirm("Are you sure you wish to switch modes? Unsaved changes will be discarded.") == false) {
			return;
		}
		this.readOnly = true;
		this.buildButtons("view");
		this.title = "View " + this.itemType;
	}

	close() {
		this.router.navigate([`/${this.returnUrl}/`]);
	}

	closePopup() {
		this.popupVisible = false;
		this.popupContact = new ClientContact();
	}

	create() {
		this.uploadEnabled = false;
		this.readOnly = false;
		this.buildButtons("create");
		this.title = "Create New " + this.itemType;
	}

	createClientDocument() {
		this.popupClientDocument.clientId = this.itemId;
		this.clientDocumentService.createSingle(this.popupClientDocument)
			.subscribe(
				() => {
					this.toastService.success("Successfully Added New Document " + this.popupClientDocument.fileName);
					this.popupClientDocument = new ClientDocument();
					this.getDocuments(this.itemId);
					this.popupVisible = false;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	createInteraction() {
		this.popupInteraction.instigatorId = this.userProfile.id;
		this.popupInteraction.clientId = this.item.id;
		this.clientInteractionService.createSingle(this.popupInteraction)
			.subscribe(
				() => {
					this.toastService.success("Successfully Added New Interaction " + this.popupClientDocument.fileName);
					this.popupInteraction = new ClientInteraction();
					this.getInteractions(this.itemId);
					this.popupVisible = false;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	createItem() {
		this.itemService.createSingle(this.item)
			.subscribe(
				() => {
					this.toastService.success("Successfully Updated " + this.itemType);
					this.item = new Client();
					this.close();
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	deleteContact(e: any) {
		if (confirm("Are you sure you wish to delete this contact? Note: Contacts attached to Sales Enquiries cannot be deleted.") == false) {
			return;
		}

		this.clientContactsService.deleteSingleById(e.row.data.id).subscribe(
			() => {
				this.toastService.success("Successfully Deleted Contact" + this.popupClientDocument.fileName);
				this.getContacts(this.itemId);
			},
			(err) => {
				this.toastService.error("Could not delete contact - " + err);
			}
		);
	}

	deleteLocation(e: any) {
		if (confirm("Are you sure you wish to delete this location? Note: Locations attached to Forecasts, Orders and Shipping Notes cannot be deleted.") == false) {
			return;
		}

		this.clientLocationService.deleteSingleById(e.row.data.id).subscribe(
			() => {
				this.toastService.success("Successfully Deleted Location");
				this.getLocations(this.itemId);
			},
			(err) => {
				this.toastService.error("Could not delete Location - " + err);
			}
		);
	}

	deleteSpecification(e: any) {
		if (confirm("Are you sure you wish to delete this specification? Note: Specifications attached to parts cannot be deleted.") == false) {
			return;
		}

		this.outsourceService.deleteSingleById(e.row.data.id).subscribe(
			() => {
				this.toastService.success("Successfully Deleted Specification");
				this.getSpecifications(this.itemId);
			},
			(err) => {
				this.toastService.error("Could not delete specification - " + err);
			}
		);
	}

	downloadDocument(e: any) {
		this.fileService.downloadFile(e.row.data.fileLookupId).subscribe(
			(response: any) => {
				const dataType = response.type;
				const binaryData = [];
				binaryData.push(response);
				const downloadLink = document.createElement("a");
				downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
				downloadLink.setAttribute("download", e.row.data.fileName);
				document.body.appendChild(downloadLink);
				downloadLink.click();
			}
		);
	}

	edit() {
		this.readOnly = false;
		this.buildButtons("edit");
		this.title = "Edit " + this.itemType;
		this.toastService.warn("You are now editing...");
	}

	editContactPopup(e: any) {
		this.clientContactsService.getSingleById(e.row.data.id).subscribe(
			(res: any) => {
				this.popupVisible = true;
				this.popupAddButtonOptions = { onClick: () => this.updateContact(), text: "Save Changes" };
				this.popupCloseButtonOptions = { onClick: () => this.closePopup(), text: "Close" };
				this.popupContact = res.response;
				this.popupTitle = "Edit Contact";
				this.popupType = "Contact";
			},
			(err) => {
				console.log(err);
				this.toastService.error("Could not edit contact");
			}
		);
	}

	editLocationPopup(e: any) {
		this.clientLocationService.getSingleById(e.row.data.id).subscribe(
			(res: any) => {
				this.popupVisible = true;
				this.popupAddButtonOptions = { onClick: () => this.updateLocation(), text: "Save Changes" };
				this.popupCloseButtonOptions = { onClick: () => this.closePopup(), text: "Close" };
				this.popupLocation = res.response;
				this.popupTitle = "Edit Location";
				this.popupType = "Location";
			},
			(err) => {
				console.log(err);
				this.toastService.error("Could not edit location");
			}
		);
	}

	editSpecificationPopup(e: any) {
		this.outsourceService.getSingleById(e.row.data.id).subscribe(
			(res: any) => {
				this.popupVisible = true;
				this.popupAddButtonOptions = { onClick: () => this.updateSpecification(), text: "Save Changes" };
				this.popupCloseButtonOptions = { onClick: () => this.closePopup(), text: "Close" };
				this.popupSpecification = res.response;
				this.popupTitle = "Edit Specification";
				this.popupType = "Specification";
			},
			(err) => {
				console.log(err);
				this.toastService.error("Could not edit Specification");
			}
		);
	}

	generateLead() {
		this.crmLeadService.generateLeadFromClient(this.itemId).subscribe(
			(res: any) => {
				this.toastService.success("CRM Lead created!");
				this.router.navigate([`admin/crmLeads/${res.response.id}_edit`]);
			},
			(err) => { console.log(err); this.toastService.error("Something Went Wrong!"); }
		);
	}

	getBankDetails() {
		this.bankDetailsService.getAll()
			.subscribe(
				(res: any) => {
					this.bankDetails = res.response.items;
				},
				(err) => { console.log(err); this.toastService.error("Something Went Wrong!"); }
			);
	}

	getContacts(id: number) {
		this.clientContactsService.getContactByParentId(id)
			.subscribe(
				(res: any) => {
					this.contacts = res.response;
				},
				(err) => { console.log(err); this.toastService.error("Something Went Wrong!"); }
			);
	}

	getDocuments(itemId: number) {
		this.clientDocumentService.getDocumentsForClientId(itemId)
			.subscribe(
				(res: any) => this.documents = res.response,
				(err) => console.log(err)
			);
	}

	getInteractions(itemId: number) {
		this.clientInteractionService.getInteractionsByClient(itemId)
			.subscribe(
				(res: any) => this.interactions = res.response,
				(err) => console.log(err)
			);
	}

	getItem(itemId: number) {
		this.itemService.getSingleById(itemId)
			.subscribe(
				(res: any) => {
					this.item = res.response;
					this.getContacts(this.item.id);
					this.getDocuments(this.item.id);
					this.getLocations(this.item.id);
					this.getSpecifications(this.item.id);
					this.getInteractions(this.item.id);
				},
				(err) => { console.log(err); this.toastService.error("Something Went Wrong!"); }
			);
		this.uploadEnabled = true;
	}

	getLocations(itemId: number) {
		this.clientLocationService.getLocationsByClientId(itemId)
			.subscribe(
				(res: any) => this.locations = res.response,
				(err) => console.log(err)
			);
	}

	getOutsideProcessTypes() {
		this.outsideProcessTypeService.getAll()
			.subscribe(
				(res: any) => {
					this.outsideProcessTypes = res.response.items;
				},
				(err) => { console.log(err); this.toastService.error("Something Went Wrong!"); }
			);
	}

	getPaymentTerms() {
		this.paymentTermsService.getAll()
			.subscribe(
				(res: any) => {
					this.paymentTerms = res.response.items;
				},
				(err) => {console.log(err); this.toastService.error("Something Went Wrong!");}
			);
	}

	getSpecifications(id: number) {
		this.outsourceService.getByClientId(id)
			.subscribe(
				(res: any) => {
					this.outsourcedSpecifications = res.response;
				},
				(err) => { console.log(err); this.toastService.error("Something Went Wrong!"); }
			);
	}

	getUserProfile() {
		this.authService.getCurrentUserProfile()
			.subscribe(
				(res: any) => {
					this.userProfile = res.response;
				},
				(err) => { console.log(err); this.toastService.error("Something Went Wrong!"); }
			);
	}

	getUserProfiles(){
		this.userProfileService.getActiveUsers()
			.subscribe(
				(res: any) => {
					this.userProfiles = res.response;
				},
				(err: any) => { console.log(err); this.toastService.error("Something Went Wrong!"); }
			);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}

	setPrimaryBilling(e: any) {
		this.clientLocationService.setPrimaryBilling(e.row.data.id).subscribe(
			() => {
				this.toastService.success("Successfully Updated Primary Billing Location");
				this.getLocations(this.item.id);
			},
			(err) => {
				console.log(err);
				this.toastService.error("Could not edit location");
			}
		);
	}

	setPrimaryDelivery(e: any) {
		this.clientLocationService.setPrimaryDelivery(e.row.data.id).subscribe(
			() => {
				this.toastService.success("Successfully Updated Primary Delivery Location");
				this.getLocations(this.item.id);
			},
			(err) => {
				console.log(err);
				this.toastService.error("Could not edit location");
			}
		);
	}

	updateContact() {
		this.clientContactsService.updateSingleById(this.popupContact.id, this.popupContact)
			.subscribe(
				() => {
					this.toastService.success("Successfully Updated Contact");
					this.closePopup();
					this.getContacts(this.item.id);
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	updateItem() {
		this.itemService.updateSingleById(this.item.id, this.item)
			.subscribe(
				() => this.toastService.success("Successfully Updated "),
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	updateLocation() {
		this.clientLocationService.updateSingleById(this.popupLocation.id, this.popupLocation)
			.subscribe(
				() => {
					this.toastService.success("Successfully Updated Location");
					this.closePopup();
					this.getLocations(this.item.id);
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	updateSpecification() {
		this.outsourceService.updateSingleById(this.popupSpecification.id, this.popupSpecification)
			.subscribe(
				() => {
					this.toastService.success("Successfully Updated Specification");
					this.closePopup();
					this.getSpecifications(this.item.id);
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	uploadFile(file: File) {
		const uploadData = new FormData();
		uploadData.append("files", file);
		this.fileService.uploadFile(uploadData)
			.subscribe(
				(res: any) => {
					this.popupClientDocument.fileLookupId = res.response[0].lookupId;
					this.popupClientDocument.fileName = res.response[0].name;
				},
				(err) => console.log(err)
			);
	}
}